const Url = process.env.VUE_APP_BASE_API;

let dataUrl = {
  interfaceAddress: {
    //页面初始化
    userInfoUrl: Url + "/user/userConfig", //用户信息
    devAllUrl: Url + "/device/devAll", //地图点信息
    //报警弹框
    answerAlarmUrl: Url + "/alarm/receive", //报警弹框的接警处理 ？？？
    alarmList: Url + "/alarm/undoneList", //报警信息列表
    //图表
    chartOptions: Url + "/chart/info",
    //二级页面
    clearAlarmTask: Url + "/alarm/end", //解除报警 ？？？
    infoDetail: Url + "/getDev/infoDetail", //获取报警设备详细信息
    alarmbounced: Url + "/alarm/bounced", //报警二级页面报警曲线
    nowStates: Url + "/getDev/nowStates", //二级页设备信息实时数据
    //设备搜索
    deviceList: Url + "/device/selectByAddress", //设备搜索
    floorDeviceList: Url + "/getDev/floor", //肖村设备搜索
    sceneSelect: Url + "/device/sceneSelect", //肖村设备搜索
    townPoint: Url + "/device/townPoint",
    //登录页
    loginUrl: Url + "/auth/login", //登录
    pointList: Url + "/device/pointList",
    //刷新token
    refreshToken: Url + "/auth/creat",

    //获取安全码
    ukeyInfo: Url + "/ukeyInfo", //？？？

    //获取登录状态
    // loginStatus:Url+'/loginStatus',

    //获取人员的轨迹
    getPos: Url + "/getPos/project", //????

    //智能消杀仪器接口
    getdeviceInfo: Url + "/uvkiller/get/deviceInfo/",

    //智能消杀仪器风机开关
    fanDriver: Url + "/uvkiller/send/fanDriver",
    //智能消杀仪器紫外线开关
    sendlamp: Url + "/uvkiller/send/lamp",
    //智能消杀仪器紫外线定时开关
    timingSet: Url + "/uvkiller/send/timingSet",
    //智能消杀仪器CO2
    emqco2: Url + "/uvkiller/close/emqCO2/",
    //智能消杀仪器二氧化碳曲线
    CO2Line: Url + "/uvkiller/get/CO2Line/",
    //智能消杀仪器消杀曲线图
    sterilizationLine: Url + "/uvkiller/get/sterilizationLine/",
    // 鼠标移动到小标牌获取设备详情接口
    getDevbounced: Url + "/device/devNameplate",
    //商业报警器点击详情页面
    getDevdetails: Url + "/device/devBaseAndNew",
    //-设备台账-周边场所列表
    getDevMarkers: Url + "/device/markers",
    
    // 监控坐席-工商业大屏基础信息-室内配套
    getDevRoomMatching: Url + "/device/roomMatching",
    // 监控坐席-工商业大屏基础信息-室内配套
    getDevVideoList: Url + "/device/videoList",
    getDevDevice_base_info: Url + "/device/device_base_info",
    getDevAnnualRecord: Url + "/device/annualRecord",
    getDevOfflineHistory: Url + "/device/offlineHistory",
    getDevRepairComplete: Url + "/device/repairComplete",
    getDevAlarm: Url + "/device/alarm",
    getDevAccInfo: Url + "/device/accInfo",
    getDevalarmrecordOne: Url + "/alarm/recordOne",
    getDevalarmroomMatching: Url + "/device/roomMatching"
    
  }
};
export default dataUrl;



// WEBPACK FOOTER //
// ./src/libs/js/interfaceAddress.js